import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../App";
import { firebaseStorage, firebaseStorageRef, useAuth } from "../firebaseConfig";
import {
    ref,
    uploadBytes,
    getDownloadURL
} from "firebase/storage";

const AddProject = () => {

    var navigate = useNavigate();
    const { pAuth, setPAuth } = useContext(AuthContext);
    const currentUser = useAuth();
    // const [currentUser, setCurrentUser] = useState(null);

    const SERVER_URL = process.env.NODE_ENV === 'development' ?
        process.env.REACT_APP_DEV_SERVER_URL : process.env.REACT_APP_PROD_SERVER_URL;

    const [formData, setFormData] = useState({
        projectName: '',
        location: '',
        description: '',
        bannerImage: FileList,
        projectImages: FileList
    });

    // const [bannerImgFbRef, setBannerImgFbRef] = useState('');
    // const [projectImgsFbRef, setProjectImgsFbRef] = useState([]);

    // const fetchCurrentUserFirebase = () => {
    //     const user = getAuth();
    //     setCurrentUser(user);
    // }
    // useEffect(() => {
    //     fetchCurrentUserFirebase();
    //     console.log('currentUser: ' + JSON.stringify(currentUser));
    // }, [currentUser]);

    const handleChange = (name, value) => {
        setFormData({ ...formData, [name]: value });
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        let dataToSend = new FormData();
        // for (let key in formData) {
        //    dataToSend.append(`\"${key}\"`, formData[key]);
        //     dataToSend.append(key, formData[key]);
        // }
        dataToSend.append("projectName", formData.projectName);
        dataToSend.append("location", formData.location);
        dataToSend.append("description", formData.description);
        dataToSend.append("bannerImage", formData.bannerImage[0]);
        // dataToSend.append("projectImages", formData.projectImages); this will append empty array

        for (let i = 0; i < formData.projectImages.length; i++) {
            dataToSend.append("projectImages", formData.projectImages[i]);
        }

        fetch(
            `${SERVER_URL}/saveProject`,
            {
                method: 'POST',
                body: dataToSend
            },
        ).then(result => result.json())
            .then(data => {
                console.log("data received - " + data);
                alert('Project Added Successfully');
                window.location.reload();
            })
            .catch(err => console.log(err));
    }

    const handleSubmitFirebase = async (e) => {
        e.preventDefault();

        var isAuthorised = false;
        await fetch(
            `${SERVER_URL}/checkAuth`,
            {
                method: 'GET',
                credentials: 'include'
            },
        ).then(result => result.json())
            .then(data => {
                isAuthorised = data['isAuthorised'];
            })
            .catch(err => console.log(err));


        if (isAuthorised && currentUser) {

            const folder = process.env.NODE_ENV === 'development' ?
                'development' : 'production';

            let projectFolder = formData.projectName.trim().toLowerCase().split(" ").join("_");
            // save project banner image in firebase
            var bannerUrl = '';
            if (formData.bannerImage[0] == null) return;
            let imageRef = ref(firebaseStorage, `${folder}/${projectFolder}/banner_image/${formData.bannerImage[0].name}`);
            await uploadBytes(imageRef, formData.bannerImage[0]).then(async (snapshot) => {
                await getDownloadURL(snapshot.ref).then((url) => {
                    bannerUrl = url;
                    // setBannerImgFbRef(bannerUrl);
                });
            });

            // save project images in firebase
            var urlList = [];
            for (let i = 0; i < formData.projectImages.length; i++) {
                imageRef = ref(firebaseStorage, `${folder}/${projectFolder}/${formData.projectImages[i].name}`);
                await uploadBytes(imageRef, formData.projectImages[i]).then(async (snapshot) => {
                    await getDownloadURL(snapshot.ref).then((url) => {
                        urlList.push(url);
                    });
                });
            }

            let dataToSend = new FormData();
            dataToSend.append("projectName", formData.projectName);
            dataToSend.append("location", formData.location);
            dataToSend.append("description", formData.description);
            // for storing images, use firebase reference path received above 
            dataToSend.append("bannerImgFbRef", bannerUrl);
            dataToSend.append("projectImgsFbRef", JSON.stringify(urlList));

            fetch(
                `${SERVER_URL}/saveProjectFb`,
                {
                    method: 'POST',
                    credentials: 'include',
                    body: dataToSend
                },
            ).then(result => result.json())
                .then(data => {
                    alert('Project Added Successfully!');
                    window.location.reload();
                })
                .catch(err => console.log(err));
        } else {
            alert('User is not authorised!');
            navigate('/');
        }
    }// end handleSubmitFirebase

    var addForm = <div className="add-project">
        <div className="container">
            <form id="add-project-form" className="contact-form add-project-form"
                encType="multipart/form-data"
                onSubmit={(e) => { handleSubmitFirebase(e) }}>

                <div className="row px-1 pt-5 pb-3">
                    <p className="m-0 py-0">Add New Project</p>
                </div>

                <div className="row form-row">
                    <div className="col-12 col-md-6 order-2 order-md-1">
                        <div className="form-box">
                            <label htmlFor="projectName">Project Name</label>
                            <input id="projectName" name="projectName" type="text" placeholder="Enter Project name"
                                value={formData['projectName']}
                                onChange={(e) => handleChange('projectName', e.target.value)}
                                required />
                        </div>

                        <div className="form-box">
                            <label htmlFor="location">Project Location</label>
                            <input id="location" name="location" placeholder="Enter Project location"
                                value={formData['location']}
                                onChange={(e) => handleChange('location', e.target.value)}
                                required />
                        </div>

                        <div className="form-box">
                            <label htmlFor="description">Description</label>
                            <textarea id="description" name="description" cols="30" rows="3"
                                value={formData['description']}
                                onChange={(e) => handleChange('description', e.target.value)}
                            ></textarea>
                        </div>

                        <div className="form-box">
                            <label htmlFor="bannerImage">Upload Banner Image</label>
                            <input id="bannerImage" name="bannerImage" type="file"
                                onChange={(e) => handleChange('bannerImage', e.target.files)} required />
                        </div>

                        <div className="form-box">
                            <label htmlFor="projectImages">Upload Site Images</label>
                            <input id="projectImages" name="projectImages" type="file" multiple
                                onChange={(e) => handleChange('projectImages', e.target.files)} required />
                        </div>

                        <div className="form-box">
                            <button className="col-6" type="submit">Add Project<img className="svg-icon" id="send-arrow" src="/assets/icons/arrow_right_icon.svg" alt="arrow" /></button>
                        </div>

                        {/* <div className="form-box">
                            <button onClick={handleReset} className="col-6" type="reset">Reset<img className="svg-icon" id="reset" src="/assets/icons/reset.svg" alt="arrow" /></button>
                        </div> */}
                    </div>

                </div> {/* end div row */}

            </form>
        </div>
    </div>;

    let content;
    if (pAuth) {
        content = addForm;
    } else {
        content = <div>Not Authorised</div>
    }

    return (
        <div>
            {content}
        </div>
    );

}

export default AddProject;